/**
 * Convert the number to a display price.
 * @example
 * 16 > 16,00
 */
export function price(value: string): string {
  return parseFloat(value).toFixed(2).replace('.', ',');
}
